import React from "react";
import PropTypes from "prop-types";
import FullPageLoader from "../FullPageLoader";

import { withRouter } from "js/components/Root/withRouter";
import { useUserSessionStore } from "stores/v2/userSessionStore";
import { LoginFailure } from "js/api/authApi";

type MyProps = {
	router: IComponentRouter;
};

class LoginMasqueradeCallback extends React.Component<MyProps> {
	componentDidMount() {
		let deviceid = this.props.router.queryString.deviceid;
		if (Array.isArray(deviceid)) {
			deviceid = (deviceid as string[])[0];
		}

		useUserSessionStore
			.getState()
			.authenticateMasquerade({
				deviceid: deviceid,
				username: this.props.router.queryString.user,
				token: this.props.router.queryString.token,
			})
			.then(() => {
				// Set masquerade to true to show the Academy MFE if it should be hidden
				useUserSessionStore.getState().setMasquerade(true);
				this.props.router.navigate("/");
			})
			.catch((error: unknown) => {
				useUserSessionStore.getState().handleAuthenticationFailure(error as LoginFailure);
				this.props.router.navigate("/login");
			});
	}

	render() {
		return (
			<div>
				<FullPageLoader message={`Logging in as "${this.props.router.queryString.user}"`} />
			</div>
		);
	}

	static propTypes = {
		router: PropTypes.object.isRequired,
	};
}

export default withRouter(LoginMasqueradeCallback);
